import {
  GET_PRODUCTION_UNFINISHED_REPORT_REQUEST,
  GET_PRODUCTION_UNFINISHED_REPORT_SUCCESS,
  GET_PRODUCTION_UNFINISHED_REPORT_ERROR
} from "../actions/types";

export const productionUnFinished = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRODUCTION_UNFINISHED_REPORT_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCTION_UNFINISHED_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_PRODUCTION_UNFINISHED_REPORT_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
